import Vue from 'vue'
import{DatePicker,MessageBox,Select,Option,Dialog,Pagination,Tooltip,Table,TableColumn,Row,Col,Card,Breadcrumb,BreadcrumbItem,MenuItem,MenuItemGroup,Menu,Submenu,Container,Header,Aside,Main,Button,Form,FormItem,Input,Message} from 'element-ui'
Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem) 
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm